import { AppBar, Box, Container, Link, Toolbar, Typography, useMediaQuery, useTheme } from "@mui/material";
import { FC } from "react";
import AgrInstSloLogo from "../../assets/agricultural-institute-slovenia-logo.png";
import NibLogo from "../../assets/nib-logo.png";
import PoloAltoAdriaticoLogo from "../../assets/polo-tecnologico-alto-adriatico-logo.png";
import RodLogo from "../../assets/rod-logo.png";
import VenetoLogo from "../../assets/veneto-cultura-logo.png";

interface IFooterProps { }

const VEN_AGR_LINK: string = "https://www.venetoagricoltura.org";
const POLO_TEC_LINK: string = "https://www.polotecnologicoaltoadriatico.it/"
const NIB_LINK: string = "https://www.nib.si/eng/"
const ROD_LINK: string = "https://rra-rod.si/en/home-2/"
const KIS_LINK: string = "https://www.kis.si/en/"

const Footer: FC<IFooterProps> = () => {
    const theme = useTheme();
    const largeMediumScreen = useMediaQuery(theme.breakpoints.up("md"));

    return <AppBar position="static">
        <Container maxWidth="xl">
            <Box sx={{
                display: "flex",
                justifyContent: "space-around",
                flexWrap: "wrap",
                alignItems: "center",
                my: 2,
                p: 2,
            }}>
                <Link href={VEN_AGR_LINK} target="_blank">
                    <Box component="img" height={largeMediumScreen ? 48 : 32} sx={{ m: 1 }} src={VenetoLogo} />
                </Link>
                <Link href={POLO_TEC_LINK} target="_blank">
                    <Box component="img" height={largeMediumScreen ? 60 : 44} sx={{ m: 1 }} src={PoloAltoAdriaticoLogo} />
                </Link>
                <Link href={NIB_LINK} target="_blank">
                    <Box component="img" height={largeMediumScreen ? 48 : 32} sx={{ m: 1 }} src={NibLogo} />
                </Link>
                <Link href={ROD_LINK} target="_blank">
                    <Box component="img" height={largeMediumScreen ? 48 : 32} sx={{ m: 1 }} src={RodLogo} />
                </Link>
                <Link href={KIS_LINK} target="_blank">
                    <Box component="img" height={largeMediumScreen ? 48 : 32} sx={{ m: 1, p: 1 }} src={AgrInstSloLogo} />
                </Link>
            </Box>
            <Toolbar disableGutters
                sx={{
                    display: "flex",
                    alignItems: "center",
                    flexDirection: "column",
                    justifyContent: "center"
                }}>
                <Typography
                    variant="body2"
                    color="primary"
                    fontWeight="500"
                    sx={{ textAlign: "center" }}
                >
                    Il progetto BEE2GETHER è co-finanziato dall'Unione europea nell'ambito del Programma Interreg VI-A Italia-Slovenia.
                </Typography>
                <Typography
                    variant="body2"
                    color="primary"
                    fontWeight="500"
                    sx={{ mb: 2, textAlign: "center" }}
                >
                    Projekt BEE2GETHER sofinancira Evropska unija v okviru Programa Interreg VI-A Italija-Slovenija
                </Typography>
            </Toolbar>
        </Container>
    </AppBar >
}

export default Footer;